import { cn } from "@/lib/utils";

const TONES = {
  light: {
    box: "bg-black/[0.04] border-black/[0.06]",
    slash: "text-[#145745]",
    text: "text-black/[0.56]",
  },
  hero: {
    box: "bg-[#0B1512]/[0.04] border-[#0B1512]/[0.10]",
    slash: "text-[#228E71]",
    text: "text-[#0B1512]/[0.72]",
  },
  dark: {
    box: "bg-white/[0.06] border-white/[0.10]",
    slash: "text-[#A8E8D4]",
    text: "text-white/[0.72]",
  },
};

export default function Eyebrow({
  text,
  tone = "light",
  className,
}: {
  text?: string;
  tone?: keyof typeof TONES;
  className?: string;
}) {
  if (!text) return null;
  const colors = TONES[tone];
  return (
    <div
      className={cn(
        "flex h-[3.75rem] w-fit items-center gap-[0.75rem] rounded-[0.5rem] border px-[1.25rem] backdrop-blur-[2px]",
        colors.box,
        className,
      )}>
      <span className={cn("font-geist text-[1.75rem] font-[600] leading-[2.5rem]", colors.slash)}>//</span>
      <p className={cn("m-0 font-geist text-[1.75rem] font-[500] uppercase leading-[2.5rem]", colors.text)}>{text}</p>
    </div>
  );
}
